<template>
    <div class="shadow-1 z-[100]">
        <!-- <div v-if="!isMobileLogin()" class="pt-1 md:pt-2 bg-gradient-to-r from-primary to-secondary" /> -->
        <!-- <div v-if="!isMobileLogin()"
            class="flex justify-between items-center px-3 xs:px-5 xl:px-3 py-4 md:py-5 xl:container"> -->
        <!-- menu -->
        <!-- <div class="md:hidden w-6 h-6" />
            <div class="flex items-end">
                <img
                    v-if="true"
                    src="@/assets/images/header/fubonLogo.svg"
                    alt="富邦人壽|雲端e櫃檯"
                    class="w-28 h-[1.49375rem] md:w-36 md:h-[1.91875rem] mr-2 md:mr-4 "
                >
                <p
                    class="text-black text-sm md:text-base font-medium leading-none md:leading-none cursor-pointer"
                    @click="showLeaveAlert(routeName.CLOUD_E_COUNTER_HOME)"
                >
                    雲端e櫃檯
                </p>
            </div>

            <img
                v-if="!isMobileLogin()"
                src="@/assets/images/header/logout_black_24dp.svg"
                alt="富邦人壽|雲端e櫃檯|登出"
                class="cursor-pointer md:hidden"
                width="24"
                height="24"
                @click="showLeaveAlert(routeName.LOGOUT)"
            >
            <div
                v-else
                class="w-6"
            />
            <div class="hidden md:block">
                <ul class="flex items-baseline">
                    <li>
                        <button
                            class="menu-list"
                            @click="showLeaveAlert(routeName.CLOUD_E_COUNTER_HOME)"
                        >
                            回首頁
                        </button>
                    </li>
                    <li>
                        <button
                            class="menu-list"
                            @click="showLeaveAlert(routeName.CLOUD_E_COUNTER_RECORD)"
                        >
                            申請紀錄
                        </button>
                    </li>
                    <li>
                        <button
                            v-if="!isMobileLogin()"
                            class="menu-list"
                            @click="showLeaveAlert(routeName.LOGOUT)"
                        >
                            登出
                        </button>
                    </li>
                </ul>
            </div> -->
        <!-- </div> -->
        <!-- 側邊選單 -->
        <Sidebar v-if="!isMobileLogin()" v-model:isMenuOpen="isMenuOpen" @openModal="showModalIllustration"
            @showLeaveAlert="showLeaveAlert" />
        <Loading :is-loading="isLoading" />
    </div>
</template>
<script>
import { inject, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { isMobileLogin } from '@/utils/is';
import Sidebar from '@/components/layout/Sidebar.vue';
import routeName from '@/router/constant.js';
import Loading from '@/components/Loading.vue';
import dialogContnet from '@/json/dialogContent.js';

export default {
    components: {
        Sidebar,
        Loading,
    },
    setup() {
        const $vfm = inject('$vfm');
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const isMenuOpen = ref(false);
        const isLoading = ref(false);
        const isShow = ref(false);
        /* 關閉手機側邊選單 */
        const menuClose = () => {
            isMenuOpen.value = false;
        };

        // 離開提示燈箱
        const showLeaveAlert = (link) => {
            isLoading.value = true;
            if (route.name === link) {
                // 關閉loading
                isLoading.value = false;
                return;
            }
            // 跳箱？
            if (route.meta.leaveAlert) {
                isLoading.value = false;
                /* 打開離開燈箱 */
                $vfm.show({
                    component: 'DialogBase',
                    params: dialogContnet.leave,
                    on: {
                        confirm() {
                            $vfm.hide('DialogBase');
                            if (link === routeName.LOGOUT) {
                                store.dispatch('permissions/clearAll', { page: link });
                            } else {
                                router.push({ name: link });
                            }
                        },
                        cancel() {
                            $vfm.hide('DialogBase');
                        },
                    },
                });
            } else {
                if (link === routeName.LOGOUT) {
                    store.dispatch('permissions/clearAll', { page: link });
                } else {
                    router.push({ name: link });
                }
            }
        };

        /* 打開申請項目說明 */
        const showModalIllustration = () => {
            $vfm.show({
                component: 'ModalIllustration',
                on: {
                    closed() {
                        $vfm.hide('ModalIllustration');
                    },
                },
            });
        };

        watch(() => route.path, (nV, oV) => {
            menuClose();
            isLoading.value = false;
        });
        return {
            isShow,
            isMenuOpen,
            isMobileLogin,
            isLoading,
            router,
            routeName,
            showModalIllustration,
            showLeaveAlert,
            open,
        };
    },
};
</script>
<style lang="scss" scoped>
.menu-list {
    @apply text-base lg:hover:bg-gray-50 text-gray-900 py-1 px-2 lg:px-3 rounded;
}
</style>
